import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
function Signup() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const assessmentId = searchParams.get("assessment");
  // const hrId = searchParams.get("hr");
  const companyId = searchParams.get("company_id");
  const candidateId = searchParams.get("candidate");
  const newJoiner = searchParams.get("is_new_joiner");
  const isStudent = searchParams.get("is_student")
  let studentFirstName = ""
  let studentLastName = ""

  useEffect(() => {
    if (isStudent == "True") {
      studentFirstName = searchParams.get("first_name")
      studentLastName = searchParams.get("last_name")
    }
  }, [isStudent])


  return (
    <div className="max-w-3xl mx-auto my-10 p-8 bg-white rounded-xl shadow-lg">
      {/* Header */}
      <div className="bg-gradient-to-r from-violet-400 to-violet-700 text-white text-center py-8 px-6 rounded-t-xl">
        <h1 className="text-2xl md:text-3xl font-bold mb-2">
          Assessment Instructions
        </h1>
        <p className="opacity-90">
          Please read all instructions carefully before starting
        </p>
      </div>

      {/* Content */}
      <div className="p-6">
        {/* Greeting */}
        {/* <h2 className="text-xl font-semibold text-gray-800 mb-6">
          Hello there,
        </h2> */}

        {/* Instructions Box */}
        <div className="bg-violet-50 border-l-4 border-violet-500 p-5 rounded-r-lg mb-8">
          {/* <h3 className="text-lg font-semibold text-violet-700 mb-3">
            Important Guidelines
          </h3> */}
          <ul className="space-y-3 list-disc pl-5 text-gray-700 text-start">
            <li>
              This assessment contains{" "}
              <span className="font-medium">60 questions</span> to be completed
              in <span className="font-medium">45 minutes.</span>
            </li>
            <li>
              All questions are{" "}
              <b>
                <i>mandatory</i>
              </b>{" "}
              and there's no negative marking.
            </li>
            <li>Please do not go back or pause once you start the assessment.</li>
            <li>Ensure you have a stable internet connection throughout.</li>
            <li>Use Chrome, Firefox or Safari browser for best experience.</li>
            <li>Once you start the assessment do not refresh the page.</li>
          </ul>
        </div>

        {/* System Requirements */}
        {/* <div className="bg-blue-50 border-l-4 border-blue-400 p-5 rounded-r-lg mb-8">
          <h3 className="text-lg font-semibold text-blue-700 mb-3">
            System Requirements
          </h3>
          <ul className="space-y-2 list-disc pl-5 text-gray-700 text-start">
            <li>Modern browser (Chrome, Firefox, Edge, or Safari)</li>
            <li>Minimum screen resolution of 1024×768</li>
            <li>Stable internet connection (2Mbps recommended)</li>
            <li>Enable JavaScript and cookies</li>
          </ul>
        </div> */}

        {/* Start Button */}
        <div className="text-center mt-10">
          <button
            onClick={() => {
              if (isStudent == "True") {
                navigate(
                  `/assessment/?assessment=${assessmentId}&company_id=${companyId}&candidate=${candidateId}&is_new_joiner=${newJoiner}&first_name=${studentFirstName}&last_name=${studentLastName}&is_student=${isStudent}`)
              } else {
                navigate(
                  `/assessment/?assessment=${assessmentId}&company_id=${companyId}&candidate=${candidateId}&is_new_joiner=${newJoiner}&is_student=${isStudent}`
                )
              }
            }
            }
            className="bg-gradient-to-r from-violet-500 to-violet-700 hover:from-violet-600 hover:to-violet-800 text-white font-semibold py-3 px-8 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1"
          >
            Click here to start assessment
          </button>

        </div>
      </div>

      {/* Footer */}
      <div className="bg-violet-50 text-center py-4 rounded-b-xl text-sm text-gray-600">
        {/* <p>
          Need help?{" "}
          <a
            href="mailto:support@selfsync.ai"
            className="text-violet-600 font-medium"
          >
            Contact support
          </a>
        </p> */}
        <p className="mt-1">
          © {new Date().getFullYear()} mytruestrength.com All rights reserved.
        </p>
      </div>
    </div>
  );
}

export default Signup;
